import { useSearchParams } from 'react-router-dom';

export interface UrlParams {
  icpid?: string;
  joid?: string;
  isExecSearch?: string;
  accountId?: string;
  sandbox?: string;
  count?: string;
  isTesting?: string;
  childIcpId?: string; // present in case of multi search
}

export const useUrlParams = (): UrlParams => {
  const [searchParams] = useSearchParams();

  return {
    icpid: searchParams.get('icpid') || undefined,
    joid: searchParams.get('joid') || undefined,
    isExecSearch: searchParams.get('isExecSearch') || undefined,
    accountId: searchParams.get('accountId') || undefined,
    sandbox: searchParams.get('sandbox') || undefined,
    count: searchParams.get('count') || undefined,
    isTesting: searchParams.get('isTesting') || undefined,
    childIcpId: searchParams.get('child_icp_id') || undefined,
  };
};
